"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactFeaturesContext = require("./ContactFeaturesContext");
Object.keys(_ContactFeaturesContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactFeaturesContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactFeaturesContext[key];
    }
  });
});